import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { ReplacementDataMedium } from '../models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';

@Injectable()
export class ReplacementDataMediumsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createReplacementDataMedium(
    payload: ReplacementDataMedium
  ): Observable<ReplacementDataMedium> {
    return this.rolesService.userHasRoleFilter<ReplacementDataMedium>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/replacement_data_media`, payload)
    );
  }

  getReplacementDataMedium(
    iri: string
  ): Observable<Array<ReplacementDataMedium>> {
    return this.rolesService.userHasRoleFilter<Array<ReplacementDataMedium>>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  update(
    iri: string,
    payload: ReplacementDataMedium
  ): Observable<ReplacementDataMedium> {
    return this.rolesService.userHasRoleFilter<ReplacementDataMedium>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteReplacementDataMedium(iri: string): Observable<any> {
    return this.rolesService.userHasRoleFilter<any>(
      'ROLE_MWS_REPLACEMENT_DATA_MEDIUM_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
